<div class="card bg-light">
    <div class="card-header bg-style">
        <img class="card-icon" ngSrc="/assets/img/top_menu/zones.svg" width="72" height="72" alt=""/>
        <div class="card-title color-light font-22 font-bold">{{ labels.zones }}</div>
    </div>
    <div class="card-content">
        @if (isRequesting()) {
            <div class="wrapper">
                <loader [dark]="true" class="loader" />
            </div>
        }
        @if (showUpdatingState()) {
            <div class="wrapper">{{ labels.updating }}</div>
        }
        @if (showZonesList()) {
            <div class="zones-list">
                @for (zonesListItem of zonesList(); track zonesListItem.zoneId) {
                    <zones-list-item [zonesListItem]="zonesListItem"
                                     (itemClick)="openZoneDialog(zonesListItem)" />
                }
            </div>
        }
        @if (showContainersList()) {
            @for (containersListItem of containersList(); track containersListItem.containerId) {
                <div class="container">
                    <div class="container-item">
                        <div> {{ containersListItem.name }}</div>
                        @if(containersListItem.signal === -3) {
                            <div class="container-status">
                                <img class="bg-cancel" data-testid="no-signal-icon"
                                     ngSrc="/assets/img/id_icons/122.svg"
                                     width="20" height="20" alt="" />
                                <div class="container-name">{{ labels.noCommunication }}</div>
                            </div>
                        }
                        <div class="container-icons"></div>
                    </div>
                    <div class="container-list">
                        @if (containersListItem.zonesList.length > 0) {
                            @for (zonesListItem of containersListItem.zonesList; track zonesListItem.zoneId) {
                                <zones-list-item [zonesListItem]="zonesListItem"
                                                 (itemClick)="openZoneDialog(zonesListItem)" />
                            }
                        } @else {
                            <div class="wrapper">{{ labels.noZones }}</div>
                        }
                    </div>
                </div>
            }
        }
    </div>
</div>
@if (showSettingsDialog() && selectedZone(); as zone) {
    <app-dialog [subtitle]="labels.settings" (close)="closeDialog()">
        <zone-settings-dialog [zone]="zone"
                              (goBack)="closeDialog()"
                              (actionSelected)="openActionDialog($event)" />
    </app-dialog>
}
@if (changeDialogData(); as dialogData) {
    <app-dialog [subtitle]="dialogData.zone.name"
                (close)="goBackToSettingsDialog()">
        <change-settings-dialog [action]="dialogData.action"
                                [selectedZone]="dialogData.zone"
                                (goBack)="goBackToSettingsDialog()"
                                (closeDialog)="closeDialog()" />
    </app-dialog>
}
